import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import Pagination from '../../../utils/pagination';
import { getStaticMemberList_action } from '../../../actions/staticAction/static_action';
import { sessionExpireMessage, toastError, tokenInavlidMessage } from '../../../utils/constants';

class Registered_list extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, currentPage: 1, recordsPerPage: 10, memberList: []
        }
        this.slider3Ref = React.createRef()
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        this.getUserList();
    }
    getUserList() {
        const { isLoading } = this.state
        this.setState({ isLoading: true })
        this.props
            .getStaticMemberList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, memberList: data.data, currentPage: 1 })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };

    memberRecord(memberList) {
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th style={{ width: '50%' }}>ORGANIZATION NAME</th>
                        <th style={{ width: '50%' }} className='text-left'>CHAPTER</th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {memberList.length > 0 ? memberList.map((data) => (
                        <tr>
                            <td>{data.CompanyName}</td>
                            <td className='text-left'>{data.Chapters}</td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={10}>No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {
        const { isLoading, memberList, currentPage, recordsPerPage } = this.state

        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = memberList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(memberList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />

                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Registered Organisations
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>About Us</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Registered Organisations</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <>
                    <section className="about-section section-padding fix bg-cover"
                        style={{ backgroundImage: 'url("assets/img/service/service-bg-2.jpg")' }}
                    >
                        <div className="container">
                            <div className="about-wrapper style-2">
                                <div className="custom_table">
                                    <div className="hack1">
                                        <div className="hack2">
                                            {this.memberRecord(currentRecords)}
                                            {memberList.length > 0 ? (
                                                <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem}
                                                    totalRecords={memberList.length}
                                                    pageLength={recordsPerPage}
                                                    setPageLength={this.updateRecordsPerPage}
                                                />
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>


                </>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, { getStaticMemberList_action })(Registered_list));